import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

type Point = { position: [number, number] };

/**
 * Fits the map to points only when a new marker is added.
 */
export function useFitToPoints(points: Point[], drawerWidthPx: number, pad = 32) {
  const map = useMap();
  const prevCountRef = useRef(points.length);

  useEffect(() => {
    // TODO: temporary – jump to Florida on load, remove when done
    // map.setView([28.3663, -81.6404], 8, { animate: true });
    // return;

    // Only fit when the number of points increases (new marker added)
    if (points.length <= prevCountRef.current) {
      prevCountRef.current = points.length;
      return;
    }
    prevCountRef.current = points.length;

    if (!points.length) return;

    const isMobile = window.innerWidth < 768;
    const effectivePad = isMobile ? 18 : pad;

    let minLat = Infinity,
      minLng = Infinity,
      maxLat = -Infinity,
      maxLng = -Infinity;
    for (const p of points) {
      const [lat, lng] = p.position;
      if (lat < minLat) minLat = lat;
      if (lng < minLng) minLng = lng;
      if (lat > maxLat) maxLat = lat;
      if (lng > maxLng) maxLng = lng;
    }

    const isSingle = minLat === maxLat && minLng === maxLng;
    const maxZoom = Math.min(isMobile ? 7 : 10, map.getMaxZoom());
    const minZoom = map.getMinZoom();

    if (isSingle) {
      map.setView([minLat, minLng], Math.max(minZoom, maxZoom), { animate: true });
      if (!isMobile) map.panBy([-(drawerWidthPx / 2), 0], { animate: true });
    } else {
      map.fitBounds(
        [
          [minLat, minLng],
          [maxLat, maxLng],
        ],
        {
          paddingTopLeft: [drawerWidthPx + effectivePad, effectivePad],
          paddingBottomRight: [effectivePad, effectivePad],
          maxZoom,
          animate: true,
        }
      );
    }
  }, [map, points, drawerWidthPx, pad]);
}